import "core-js/modules/es.array.every";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import _slicedToArray from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSellerList, getShopDataAnalyse, shopDataDownload, getSpuGroupList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import * as DateUtil from '@/utils/date';
import { saveAs } from 'file-saver';

var _this;

export default {
  name: 'BairunBianlidianLirunAnalyse',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatTime: function formatTime(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'MM-dd hh:mm');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerShortName: function getSellerShortName(sellerId) {
      if (sellerId == 0) {
        return '总';
      }

      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId === sellerId) {
          return _this.sellerOptions[i].shortSellerName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: '',
      type: '',
      sellerOptions: [],
      showSelSeller: false,
      loading: false,
      searchSpuGroupOptions: [],
      searchInfo: {
        period: 0,
        dateTime: new Date(),
        startTime: '',
        endTime: '',
        timeTag: 'date',
        sellerId: 0
      },
      endTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          // return ture表示日期不可选
          return !DateUtil.isBeforeMonth(_this.searchInfo.startTime, time.Format('yyyy-MM-dd hh:mm:ss'), 1, 'date');
        }
      },
      checkTab: 'seller',
      lirunTable: {
        table: []
      },
      lirunSkuTable: {
        table: [],
        category: [],
        categoryColumn: '全部分类',
        summary: [],
        page: 1,
        pageSize: 10
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sellerOptions, searchSpuGroupOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getSellerList({
                  page: 1,
                  pageSize: 999999,
                  sellerSource: 1,
                  donNotShowLoading: true
                });

              case 2:
                sellerOptions = _context3.sent;
                _this3.sellerOptions = sellerOptions.data.list;

                if (_this3.sellerOptions.length === 1) {
                  _this3.sellerId = _this3.sellerOptions[0].sellerId;
                }

                _context3.next = 7;
                return getSpuGroupList({
                  page: 1,
                  pageSize: 999999,
                  spuGroupStatus: 1,
                  donNotShowLoading: true
                });

              case 7:
                searchSpuGroupOptions = _context3.sent;
                _this3.searchSpuGroupOptions = searchSpuGroupOptions.data.list || [];

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onInputChange: function onInputChange() {
      this.$forceUpdate();
    },
    onCheckTime: function onCheckTime() {
      if (this.searchInfo.timeTag === 'custom') {
        this.searchInfo.period = 0;
        this.searchInfo.startTime = '';
        this.searchInfo.endTime = '';
        return;
      }

      this.onCheckTab();
    },
    onCheckTab: function onCheckTab() {
      var _this4 = this;

      if (this.searchInfo.timeTag === 'custom') {
        this.searchInfo.period = 0;
      } else {
        var _DateUtil$getStartAnd = DateUtil.getStartAndEnd(this.searchInfo.timeTag, this.searchInfo.dateTime);

        var _DateUtil$getStartAnd2 = _slicedToArray(_DateUtil$getStartAnd, 3);

        this.searchInfo.startTime = _DateUtil$getStartAnd2[0];
        this.searchInfo.endTime = _DateUtil$getStartAnd2[1];
        this.searchInfo.period = _DateUtil$getStartAnd2[2];
      }

      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        return;
      }

      this.lirunTable.page = 1;
      this.lirunTable.pageSize = 10;
      this.showSelSeller = false;

      if (this.checkTab === 'seller') {
        this.initLirun();
      }

      if (this.checkTab === 'sku') {
        this.initSkuLirun();
      }

      this.$nextTick(function () {
        _this4.$refs.lirunTable && _this4.$refs.lirunTable.doLayout();
        _this4.$refs.skuTable && _this4.$refs.skuTable.doLayout();
      });
    },
    getSellerSummaries: function getSellerSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        if (!['tradeAmount', 'goodsCosts', 'grossProfit'].includes(column.property)) {
          sums[index] = '';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return (prev + curr).toFixed(2);
            } else {
              return prev.toFixed(2);
            }
          }, 0);
        } else {
          sums[index] = '';
        }
      });

      if (sums[1] > 0) {
        var percent = (sums[1] - sums[2]) / sums[1] * 100;
        sums[sums.length - 1] = percent.toFixed(2) + '%';
      } else {
        sums[sums.length - 1] = '0%';
      }

      return sums;
    },
    getSkuSummaries: function getSkuSummaries(param) {
      return this.lirunSkuTable.summary;
    },
    // 站点分析-站点利润
    initLirun: function initLirun() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.loading = true;
                param = {
                  'dataType': 7,
                  'sellerId': _this5.searchInfo.sellerId,
                  'period': _this5.searchInfo.period,
                  'timeTag': _this5.searchInfo.timeTag,
                  'startTime': _this5.searchInfo.startTime,
                  'endTime': _this5.searchInfo.endTime
                };
                _context4.next = 4;
                return getShopDataAnalyse(param);

              case 4:
                res = _context4.sent;
                _this5.loading = false;

                if (res.code == 0) {
                  _this5.lirunTable.table = res.data.list || [];

                  _this5.$nextTick(function () {
                    _this5.$refs.lirunTable && _this5.$refs.lirunTable.doLayout();
                  });
                }

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 站点分析-sku利润
    initSkuLirun: function initSkuLirun() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.loading = true;
                param = {
                  'dataType': 8,
                  'sellerId': _this6.searchInfo.sellerId,
                  'period': _this6.searchInfo.period,
                  'timeTag': _this6.searchInfo.timeTag,
                  'startTime': _this6.searchInfo.startTime,
                  'endTime': _this6.searchInfo.endTime,
                  'page': _this6.lirunSkuTable.page,
                  'pageSize': _this6.lirunSkuTable.pageSize,
                  'goodsName': _this6.searchInfo.goodsName,
                  'spuNoStr': _this6.searchInfo.spuNoStr,
                  'categoryNo': _this6.searchInfo.categoryNo || ''
                };
                _context5.next = 4;
                return getShopDataAnalyse(param);

              case 4:
                res = _context5.sent;
                _this6.loading = false;

                if (res.code == 0) {
                  _this6.lirunSkuTable.total = res.data.total;
                  _this6.lirunSkuTable.page = res.data.page;
                  _this6.lirunSkuTable.pageSize = res.data.pageSize;
                  _this6.lirunSkuTable.table = res.data.list || [];
                  _this6.lirunSkuTable.summary = ['合计', '', res.data.heji.totalOrderNum, res.data.heji.totalGoodsNum, res.data.heji.totalOrderSaleAmount, res.data.heji.totalOrderDiscount, res.data.heji.totalTradePay, res.data.heji.totalGoodsCost, res.data.heji.grossProfit, (Number(res.data.heji.grossMargin) * 100).toFixed(2) + '%'];
                  if (!_this6.searchInfo.categoryNo) _this6.lirunSkuTable.category = res.data.heji.categoryList ? res.data.heji.categoryList.map(function (item) {
                    return {
                      'text': item.categoryName,
                      'value': item.categoryNo
                    };
                  }) : [];

                  _this6.$nextTick(function () {
                    _this6.$refs.skuTable && _this6.$refs.skuTable.doLayout();
                  });
                }

                _this6.$forceUpdate();

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onSearchByCategory: function onSearchByCategory(column) {
      var _this7 = this;

      this.searchInfo.categoryNo = column.categoryNo[0];
      this.lirunSkuTable.categoryColumn = column.categoryNo[0] ? this.lirunSkuTable.category.filter(function (item) {
        return item.value == _this7.searchInfo.categoryNo;
      })[0].text : '全部分类';
      this.onCheckTab();
    },
    handleSkuSizeChange: function handleSkuSizeChange(val) {
      this.lirunSkuTable.pageSize = val;
      this.initSkuLirun();
    },
    handleSkuCurrentChange: function handleSkuCurrentChange(val) {
      this.lirunSkuTable.page = val;
      this.initSkuLirun();
    },
    onDownload: function onDownload() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                param = {
                  'sellerId': _this8.searchInfo.sellerId,
                  'period': _this8.searchInfo.period,
                  'timeTag': _this8.searchInfo.timeTag,
                  'startTime': _this8.searchInfo.startTime,
                  'endTime': _this8.searchInfo.endTime,
                  'goodsName': _this8.searchInfo.goodsName,
                  'spuNoStr': _this8.searchInfo.spuNoStr,
                  'categoryNo': _this8.searchInfo.categoryNo || ''
                };

                if (_this8.checkTab === 'seller') {
                  param.dataType = 7;
                }

                if (_this8.checkTab === 'sku') {
                  param.dataType = 8;
                }

                _context6.next = 5;
                return shopDataDownload(param);

              case 5:
                res = _context6.sent;

                if (res.code == 0) {
                  saveAs(res.data.fileUrl);
                }

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};